// extracted by mini-css-extract-plugin
export default {"richtext":"r6zlaIYgEakugm5ck2gd","medium":"qKALUXAxficrCZqjGNyq","normal":"iq7KkNIprgnTXQHh6b0I","responsive":"TH8BvqQNmBgiIoZC78lM"};